import React from "react";
import "../assets/css/Footer.css";
import GitHub from "../assets/static/github.png";
import Insta from "../assets/static/instagram.png";
import Linkedin from "../assets/static/linkedin.png";
import Mail from "../assets/static/mensaje.png";

export default function Footer() {
  const handleLinkedin = () => {
    window.open(
      "https://www.linkedin.com/in/nahuel-orselli-912850236/",
      "_blank"
    );
  };
  const handleInsta = () => {
    window.open("https://www.instagram.com/nahuelorselli.jsx/", "_blank");
  };
  const handleGit = () => {
    window.open("https://github.com/NahuelOrselli", "_blank");
  };
  return (
    <>
      <div className="Footer">
        <div className="Footer-text">
          <h2>Get In Touch</h2>
          <p>
          Although I am not currently looking for new opportunities,
          if you have other request or question,don't hesitate to contact me.
          </p>
        </div>
        <div className="Footer-social">
          <ul className="Footer-ul">
            <li onClick={handleLinkedin} className="Footer-li">
              <img src={Linkedin} alt="" />
            </li>
            <li onClick={handleInsta} className="Footer-li">
              <img src={Insta} alt="" />
            </li>
            <li onClick={handleGit} className="Footer-li">
              <img src={GitHub} alt="" />
            </li>
            <li
              onClick={() =>
                (window.location = "mailto:orselli.nahuel@gmail.com")
              }
              className="Footer-li"
            >
              <img src={Mail} alt="" />
            </li>
          </ul>
        </div>
        <div className="Footer-copy">
          <p>Designed & built by Nahuel Orselli © 2022</p>
        </div>
      </div>
    </>
  );
}
